export default [
    {
        path: '/select',
        name: 'select',
        component: () => import('VIEWS/Select.vue')
    }
]